/** 
 * This is how the virtual lab is loaded in the browser when used via an iframe.
 */

/*global require*/
'use strict';

import "../styles/main.scss";

// import all the json and icons
function importAll (r) {
  r.keys().forEach(r);
}
importAll(require.context('./resources/', true, /\.json$/));
importAll(require.context('../styles/icons/', true, /\.svg$/));
import '../images/logo.gif';

// The original define[]

import Backbone from 'backbone';
import AppModel from 'models/App';
import AppView from 'views/App';
import $ from 'jquery';
import XMLLogger from 'logging/XMLLogger';
import TorusMessager from 'torus/TorusMessager';

import('labInfo')
    .then((labInfoTemp) => {
      labInfo = labInfoTemp
    });

Backbone.history.start();

if(loggingEnabled) {
    var logger = new XMLLogger(userName, session, destination);
}
else {
    console.log("logging disabled");
}

// Could add a global to the .html templates to enable/suppress this if desired
var messager = new TorusMessager();


// Create the app and appView once a message is posted:
window.addEventListener("message", function(e) {
    if (e.data.assignmentPath || e.data.labObject) {
        userName = e.data.userName || userName;
        session = e.data.session || session;
        loggingEnabled = e.data.loggingEnabled || loggingEnabled;
        destination = e.data.destination || destination;
        language = e.data.language || "en";
        allowLoadAssignment = e.data.allowLoadAssignment !== false;
        showFirstTimeTips = e.data.showFirstTimeTips !== false;

        document.getElementsByTagName("body")[0].style.backgroundColor = "#dddddd";

        function getWorkbenchItems() {
            return labInfo.getWorkbenchItems();
        }
        function isFinishedLoading() {
            return labInfo.isFinishedLoading();
        }
        function getSelectedItem() {
            return labInfo.getSelectedItem();
        }
        function loadAssignment(assignmentPathTemp) {
            // Huge hack communicating with the vlab using this awkward local variable
            // rather than passing the assignmentPath as a function
            assignmentPath = assignmentPathTemp;
            if (labInfo) {
                labInfo.loadAssignment();
            }
        }
        function loadAssignmentJSON(jsObject) {
            labInfo.loadAssignmentJSON(jsObject);
        }
        
        if (e.data.labObject) {
            loadAssignmentJSON(e.data.labObject);
        } else {
            assignmentPath = e.data.assignmentPath || assignmentPath;
            loadAssignment(assignmentPath); 
        }
    }

});

var app = new AppModel();
var appView = new AppView({ model: app, el: $("#vlab")});
